import { Intervention, Location, LocationDAO } from '@agroone/entities'
import { ChangeDetectionStrategy, Component, inject, input, SecurityContext } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { BndButton } from '@bonduelle-it/storybook'
import { TranslateService } from '@ngx-translate/core'
import { DateWeekNumberDirective } from '../../../../directives/date-week-number.directive'
import { TranslateConstantPipe } from '../../../../pipes'
import { SharedConstantService } from '../../../../services'
import { requireDefined } from '../../../../utils/require-defined.util'
import { InterventionFoodSafetyTypes } from '../../enums/intervention-foodsafety-types.enum'

@Component({
  selector: 'food-safety',
  templateUrl: './food-safety.component.html',
  styleUrls: ['./food-safety.component.scss'],
  imports: [TranslateConstantPipe, DateWeekNumberDirective, BndButton],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FoodSafetyComponent {
  readonly intervention = input.required<Intervention>()
  public constantService: SharedConstantService = inject(SharedConstantService)
  public translate: TranslateService = inject(TranslateService)
  public interventionFoodSafetyTypes = InterventionFoodSafetyTypes
  private _domSanitizer = inject(DomSanitizer)

  public openMaps(location: Location | LocationDAO) {
    if (location.longitude && location.latitude) {
      const url = this._domSanitizer.sanitize(
        SecurityContext.URL,
        `https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`,
      )
      window.open(requireDefined(url, 'the sanitized maps URL'), '_blank')
    }
  }
}
